import { SvgIcon } from "@mui/material";

function Fb(props) {
  return (
    <SvgIcon viewBox="0 0 58 58" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 29.1619C0 43.5798 10.4714 55.5688 24.1667 58V37.0548H16.9167V29H24.1667V22.5548C24.1667 15.3048 28.8381 11.2786 35.4453 11.2786C37.5381 11.2786 39.7952 11.6 41.8881 11.9214V19.3333H38.1833C34.6381 19.3333 33.8333 21.1047 33.8333 23.3619V29H41.5667L40.2786 37.0548H33.8333V58C47.5286 55.5688 58 43.5822 58 29.1619C58 13.1225 44.95 0 29 0C13.05 0 0 13.1225 0 29.1619Z"
      />
    </SvgIcon>
  );
}

export default Fb;
